const YOUTUBE_EMBED_HOSTS = new Set([
  'youtube.com',
  'www.youtube.com',
  'youtube-nocookie.com',
  'www.youtube-nocookie.com'
])

const ALLOWED_IFRAME_ATTRIBUTES = [
  'src',
  'title',
  'allow',
  'allowfullscreen',
  'referrerpolicy',
  'frameborder'
] as const

export const sanitizeYoutubeEmbedCode = (embedCode?: string | null): string => {
  if (!embedCode || import.meta.server || typeof DOMParser === 'undefined') {
    return ''
  }

  const document = new DOMParser().parseFromString(embedCode.trim(), 'text/html')
  const elements = Array.from(document.body.children)

  if (elements.length !== 1 || elements[0].tagName !== 'IFRAME') {
    return ''
  }

  const sourceIframe = elements[0] as HTMLIFrameElement
  const source = sourceIframe.getAttribute('src')

  if (!source) {
    return ''
  }

  try {
    const url = new URL(source)
    const isYoutubeEmbed = url.protocol === 'https:'
      && YOUTUBE_EMBED_HOSTS.has(url.hostname.toLowerCase())
      && /^\/embed\/[A-Za-z0-9_-]+\/?$/.test(url.pathname)

    if (!isYoutubeEmbed) {
      return ''
    }

    const iframe = document.createElement('iframe')

    ALLOWED_IFRAME_ATTRIBUTES.forEach((attribute) => {
      const value = sourceIframe.getAttribute(attribute)
      if (value !== null) {
        iframe.setAttribute(attribute, value)
      }
    })

    iframe.setAttribute('src', url.toString())
    iframe.setAttribute('title', iframe.getAttribute('title') || 'YouTube live stream')
    iframe.setAttribute('allow', iframe.getAttribute('allow') || 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share')
    iframe.setAttribute('allowfullscreen', '')
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin')
    iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-presentation allow-popups')
    iframe.setAttribute('frameborder', '0')

    return iframe.outerHTML
  } catch {
    return ''
  }
}
